import { createStyles, makeStyles } from "@material-ui/core/styles";

import { AppMenuItem } from "../components-molecules";
import List from "@material-ui/core/List";
import { useEffect, useState } from "react";
import { roles } from "../utils/roles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AppMenu = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const data = useSelector((state: any) => state.login);
  const [menuItems, setMenuItems] = useState([]);
  const [activeRoute, setActiveRoute] = useState<string>(location.pathname);

  useEffect(() => {
    setActiveRoute(location.pathname);
  }, [location]);

  useEffect(() => {
    const role = data?.isCollectOnly ? "CollectionOnly" : data.role;
    const routes = roles[role].routes.filter((item: any) => item?.sidebar);
    if (data?.isCollectEnabled && !data?.isCollectOnly) {
      routes.splice(1, 0, ...roles["CollectionEnabled"].routes);
    }
    setMenuItems(routes);
  }, [data]);
  return (
    <List component="nav" className={classes.appMenu} disablePadding>
      {menuItems.map((item: any, index: number) => {
        let isSecondLevel = false;
        item.secondRoutes &&
          item.secondRoutes.forEach((s) => {
            if (activeRoute.includes(s)) {
              isSecondLevel = true;
            }
          });

        return (
          <AppMenuItem
            {...{
              name: t(item.sidebar),
              link: item.route,
              active: item.route === activeRoute,
              isSecondLevel: isSecondLevel,
            }}
            key={item.route}
            icon={item.icon}
          />
        );
      })}
    </List>
  );
};

const drawerWidth = 256;

const useStyles = makeStyles(
  createStyles({
    appMenu: {
      width: "100%",
      paddingInline: "4px",
    },
    navList: {
      width: drawerWidth,
    },
    menuItem: {
      width: drawerWidth,
    },
    menuItemIcon: {
      color: "#97c05c",
    },
  })
);

export default AppMenu;
